import React, {Component} from "react";
import {connect} from "react-redux";
import {AppState} from "../store/reducers";
import {deletePointZoneForm} from "../store/actions/pointZoneForm";
import {Alert, Button, Spinner} from "reactstrap";


type PointZoneDeleteType = {
    deletePointZoneForm: (id: number, formId: number) => void
    cancelHandler?: () => void
    id: number
    formId: number
    changeLoading: boolean
    changeError: string
}

class PointZoneDeleteContainer extends Component<PointZoneDeleteType> {

    deleteHandler = () =>{
        const {id, formId, deletePointZoneForm} = this.props;
        deletePointZoneForm(id,formId)
    };

    render() {
        const {changeLoading, changeError, cancelHandler} = this.props;

        return (
            <>
                {changeError &&
                (<Alert className={'mt-3'} color={'danger'}>
                    {changeError}
                </Alert>)}
                <div className={'text-right'}>
                    {cancelHandler && <Button onClick={cancelHandler} color={'primary'} className={'mr-3'}>Не удалять</Button>}
                    <Button onClick={this.deleteHandler} color={'danger'} disabled={changeLoading}>
                        {changeLoading &&
                        (<Spinner
                            size="sm"
                        />)}
                        Да, удалить
                    </Button>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: AppState) => {
    const {changeLoading, changeError} = state.pointZoneForm;

    return {
        changeLoading,
        changeError
    }
};

const mapDispatchToProps = {
    deletePointZoneForm
};


export default connect(mapStateToProps, mapDispatchToProps)(PointZoneDeleteContainer);
